module.exports = __webpack_public_path__ + "static/media/cardFourth.a03cb64e.svg";